import React, { Component } from "react";

import DraggableModal from '../../../../components/Modal/DraggableModal';

import { connect } from 'react-redux';
import './ConditionOrderGuideModal.scss';
import _ from 'lodash';
import { FormattedMessage } from "react-intl";
import { symbolService } from "services";
import { ToastUtil } from "utils";

class ConditionOrderGuideModal extends Component {

    state = {
        currentOrderType: '',
        htmlContent: '',
        allContent: ''
    }

    _setState = (obj, callback) => {
        if (this.mounted) {
            this.setState(obj, callback);
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }

    componentDidMount() {
        const { currentType } = this.props;
        this.mounted = true;
        if (currentType) {
            this._setState({ currentOrderType: currentType }, () => {
                this.getHtmlContentGuide();
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {
        const { isOpen, currentType } = this.props;
        const { isOpen: prevIsOpen } = prevProps;
        if (isOpen !== prevIsOpen && isOpen === true) {
            this._setState({ currentOrderType: currentType }, () => {
                this.getHtmlContentGuide();
            })
        }

        if (this.state.currentOrderType !== prevState.currentOrderType && this.state.currentOrderType) {
            this.setHtmlContentGuide();
        }
    }

    setHtmlContentGuide = () => {
        const { currentOrderType, allContent } = this.state;
        const { lang } = this.props;
        this.setState({ htmlContent: allContent[`${currentOrderType}`] && allContent[`${currentOrderType}`][`${lang}`] ? allContent[`${currentOrderType}`][`${lang}`] : '' });
    }

    getHtmlContentGuide = () => {
        const { lang } = this.props;
        const { currentOrderType } = this.state;
        symbolService.getConditonOrderGuide()
            .then(data => {
                if (data && !_.isEmpty(data)) {
                    this.setState({ allContent: data, htmlContent: data[`${currentOrderType}`] && data[`${currentOrderType}`][`${lang}`] ? data[`${currentOrderType}`][`${lang}`] : '' });
                }
            }).catch(err => {
                ToastUtil.errorApi(err, 'trade.condition-order.guide.fail-to-load-guide');
            })
    }

    setCurrentOrderType = (orderType) => {
        this._setState({ currentOrderType: orderType })
    }


    render() {
        const { isOpen, onClose, orderTypeData, currentType } = this.props;
        const { currentOrderType, htmlContent } = this.state;


        let dataToDisplay = [...orderTypeData];
        dataToDisplay.unshift(
            {
                title: "Quy định chung",
                enum: 'COMMON'
            }
        )

        return (
            <DraggableModal
                isOpen={isOpen}
                toggle={onClose}
                onClose={onClose}
                className={'condition-order-guide'}
                titleId={'trade.condition-order.guide.title'}
            >
                <div className="body">
                    <div className="col-12 row content">
                        <div className="signal-name">
                            {dataToDisplay && dataToDisplay.length > 0 && dataToDisplay.map(item => {
                                return (
                                    <div className={'item-signal-type txt---500-14-20 ' + (currentOrderType && currentOrderType === item.enum ? 'active' : '')}
                                        onClick={() => this.setCurrentOrderType(item.enum)}
                                    >
                                        {item.title}
                                        {/*currentType && currentType === item.enum && <span className="base-type-dot"></span>*/}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="description">

                            {/*!_.isEmpty(currentSignalType) &&
                                currentSignalType.description
                            */}
                            <div className="txt---500-14-22" dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
                        </div>
                        {/*<div className="col-12 footer">
                            <button className="btn btn-confirm txt---500-14-20" onClick={onClose}>
                                <FormattedMessage id="datx-signal-guide.close" />
                            </button>
                        </div>*/}
                    </div>
                </div>
            </DraggableModal>
        );
    }

}

const mapStateToProps = state => {

};

const mapDispatchToProps = dispatch => {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ConditionOrderGuideModal);